<template>
  <div class="move-input" :class="classes">
    <div class="label">
      <label v-if="label">{{ label }}</label>
      <slot name="right"></slot>
    </div>
    <i-input v-model="mvalue" class="input" v-bind="$attrs" @on-change="change">
      <template slot="suffix">
        <slot name="suffix"></slot>
      </template>
      <template slot="prefix">
        <slot name="prefix"></slot>
      </template>
    </i-input>
    <slot name="bottom"></slot>
  </div>
</template>

<script>
export default {
  name: 'MoveInput',
  props: {
    label: {
      type: String,
    },
    size: {
      type: String,
      default: 'default',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mvalue: this.value,
    };
  },
  computed: {
    classes() {
      return `move-input-${this.size}`;
    },
  },
  watch: {
    value(nv) {
      if (nv !== this.mvalue) {
        this.mvalue = nv;
      }
    },
  },
  methods: {
    change() {
      this.$emit('input', this.mvalue);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.move-input {
  width: 100%;
  border-radius: 6px;
  &.move-input-large {
    .input {
      height: 36px;
    }
  }
  .input {
    height: 46px;
  }
  .label {
    .font-light;
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: @app-black-color;
  }
  &.move-input-large {
    .label {
      padding: 10px 0px;
    }
  }
}
</style>
<style lang="less">
@import '../../assets/css/main.less';
.move-input-error {
  .ivu-input {
    border: 1px solid @app-error-color;
  }
}
&.move-input-large {
  .ivu-input {
    height: 36px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 36px;
  }
}
</style>
